export default [
    {
        src: 'images/guardian_manual/MANUAL1.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL1.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MISIONVISION.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MISIONVISION.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL4.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL4.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL5.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL5.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL6.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL6.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL7.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL7.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL8.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL8.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL9.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL9.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL10.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL10.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL11.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL11.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL12.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL12.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL13.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL13.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL14.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL14.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL15.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL15.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL16.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL16.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL17.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL17.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL18.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL18.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL19.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL19.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL20.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL20.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL21.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL21.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL22.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL22.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL23.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL23.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL24.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL24.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL25.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL25.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL26.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL26.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL27.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL27.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL28.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL28.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL29.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL29.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL30.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL30.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL31.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL31.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL32.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL32.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL33.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL33.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL34.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL34.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL35.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL35.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL36.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL36.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL37.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL37.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL38.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL38.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL39.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL39.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL40.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL40.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL41.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL41.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL42.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL42.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL43.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL43.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL44.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL44.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL45.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL45.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL46.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL46.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL47.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL47.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL48.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL48.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL49.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL49.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL50.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL50.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL51.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL51.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL52.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL52.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL53.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL53.jpg',
        w: 1713,
        h: 2539
    },
    {
        src: 'images/guardian_manual/MANUAL54.jpg',
        thumbnail: 'images/guardian_manual/guardian_manual_miniature/MANUAL54.jpg',
        w: 1713,
        h: 2539
    }
] 